/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{FeatureSymbologyDrawOrder as s}from"../../enums.js";import{Technique as e}from"./Technique.js";class o extends e{constructor(){super(...arguments),this.overrideStencilRef=null,this.symbologyPlane=s.FILL,this.postProcessingEnabled=!1}postProcess(s,e){}}export{o as FeatureTechnique};
